import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { RichText } from 'prismic'

import HorizontalWrapper from '../HorizontalWrapper'
import QuoteSvg from 'assets/svg/quote.inline.svg'
import { Subtitle } from 'components/ui/Typography'

import s from './Quote.module.scss'
const cn = classNames.bind(s)

const Quote = ({ data }) => {
  const { primary } = data

  if (!primary) return null
  return (
    <HorizontalWrapper>
      <div className={cn('inner')}>
        {primary.quote && (
          <div className={cn('quote')}>
            <QuoteSvg />
            <div className="headline2">{RichText.render(primary.quote)}</div>
          </div>
        )}
        {primary.author && (
          <div className={cn('author')}>
            <Subtitle>{primary.author}</Subtitle>
          </div>
        )}
      </div>
    </HorizontalWrapper>
  )
}

Quote.propTypes = {
  data: PropTypes.object.isRequired,
}

// Quote.whyDidYouRender = true

export default Quote
